<template>
  <div>
    <h1 class="mb-6 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('universitas.index')">
        Universitas
      </inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama" />
          <text-input
            v-model="form.npsn"
            :error="form.errors.npsn"
            class="pr-6 pb-8 w-full lg:w-1/6"
            label="NPSN" />
          <text-input
            v-model="form.abbreviation"
            :error="form.errors.abbreviation"
            class="pr-6 pb-8 w-full lg:w-1/6"
            label="Singkatan" />
          <text-input
            v-model="form.accreditation"
            :error="form.errors.accreditation"
            class="pr-6 pb-8 w-full lg:w-1/6"
            label="Akreditasi" />
          <select-input
            v-model="form.ref_kota_studi_id"
            :error="form.errors.ref_kota_studi_id"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Kota Studi">
            <option :value="null" />
            <option
              v-for="kota_studi in kotaStudis"
              :key="kota_studi.id"
              :value="kota_studi.id">
              {{ kota_studi.name }}
            </option>
          </select-input>
          <select-input
            v-model="form.pt_type"
            :error="form.errors.pt_type"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Kategori PT">
            <option :value="null" />
            <option value="PTA">
              PTA
            </option>
            <option value="PTK">
              PTK
            </option>
            <option value="PTN">
              PTN
            </option>
            <option value="PTS">
              PTS
            </option>
          </select-input>
          <text-input
            v-model="form.rector_name"
            :error="form.errors.rector_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Rektor" />
          <text-input
            v-model="form.phone"
            :error="form.errors.phone"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="No.Telp" />
          <div class="w-full" />
          <text-input
            v-model="form.email"
            :error="form.errors.email"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Email Institusi" />
          <text-input
            v-model="form.web"
            :error="form.errors.web"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Alamat Web (Situs)" />
          <text-area-input
            v-model="form.address"
            :error="form.errors.address"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Alamat Institusi" />
          <text-area-input
            v-model="form.descriptions"
            :error="form.errors.descriptions"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Catatan" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Create Universitas
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextAreaInput from '@/Shared/TextAreaInput'
import { useForm, Link } from '@inertiajs/vue2'

export default {
    metaInfo: { title: 'Create Universitas' },
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        TextAreaInput,
        'inertia-link': Link,
    },
    layout: Layout,
    props: {
        kotaStudis: Array,
    },
    remember: 'form',
    data () {
        return {
            form: useForm({
                name: null,
                npsn: null,
                ref_kota_studi_id: null,
                abbreviation: null,
                accreditation: null,
                address: null,
                email: null,
                phone: null,
                web: null,
                pt_type: null,
                rector_name: null,
                descriptions: null,
            }),
        }
    },
    methods: {
        store () {
            this.form.post(this.route('universitas.store'))
        },
    },
}
</script>

